var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics"},[_c('h1',{staticClass:"analytics__title"},[_vm._v("Аналитика")]),_c('div',{staticClass:"analytics__graph"},[_c('GraphComponent',{attrs:{"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }